<template>
  <div class="w3-col w3-left-align">
    <ContentHeader v-bind:title="$t('waiting-time-arrival-report')"></ContentHeader>
  </div>
  <ReportItem
    :columns="pdfColumns"
    :objects="tableData"
    :file-name="$t('waiting-time-arrival-report_')"
    :start-day="$helper.lastMonth()"
    :end-day="$helper.today()"
    @emittedDays="onDateUpdate"
  >
    <StandardTable
      :sort-options="true"
      :no-content="'noData'"
      :column-definitions="columnDefinitions"
      :records="tableData"
    />
  </ReportItem>
</template>

<script>
import StandardTable from "../../common/StandardTable.vue";
import ReportItem from "./ReportItem.vue";
import ContentHeader from "../../common/ContentHeader.vue"

export default {
  name: "WaitingTimesArrival",
  components: { StandardTable, ReportItem, ContentHeader },
  mounted() {
    const days = [this.$helper.lastMonth(), this.$helper.today()];
    this.onDateUpdate(days);
  },
  data() {
    return {
      columnDefinitions: [
        { key: "service", label: this.$t("service"), dataKey: "service" },
        { key: "site", label: this.$t("site"), dataKey: "site" },
        {
          key: "average_waiting_time",
          label: `${this.$t("average_waiting_time")} (${this.$t("seconds")})`,
          dataKey: "averageWaitingTime",
        },
        {
          key: "median_waiting_time",
          label: `${this.$t("median_waiting_time")} (${this.$t("seconds")})`,
          dataKey: "medianWaitingTime",
        },
      ],
      tableData: [],
      pdfColumns: [
        { title: this.$t("service"), dataKey: "service" },
        { title: this.$t("site"), dataKey: "site" },
        {
          title: `${this.$t("average_waiting_time")} (${this.$t("seconds")})`,
          dataKey: "averageWaitingTime",
        },
        { title: this.$t("median_waiting_time"), dataKey: "medianWaitingTime" },
      ],
    };
  },
  methods: {
    onDateUpdate(days) {
      const queryString = `startDate=${this.$helper.flipDateFormat(
        days[0]
      )}&endDate=${this.$helper.flipDateFormat(days[1])}`;
      this.fetchWaitingTimeStartingFromArrivalReport(queryString);
    },
    fetchWaitingTimeStartingFromArrivalReport(queryString) {
      this.$restClient.reports
        .waitingTimesStartingFromArrival({ query: queryString })
        .then((response) => {
          response.data.forEach(w => {
            w.averageWaitingTime = Math.round(w.averageWaitingTime);
            w.medianWaitingTime = Math.round(w.medianWaitingTime);
          });
          this.tableData = response.data;
        })
        .catch((err) => {
          console.log(err);
          this.$notify.notifyError({
            title: this.$t("failed"),
          });
        });
    },
  },
};
</script>
